import axios from 'axios';
import { API_BASE_URL } from '../config/productionLink';

// ── Default API: Connected to Backend on PC 2 (erp.learninghub.ind.in) ───────
const api = axios.create({
    baseURL: API_BASE_URL,
    headers: { 'Content-Type': 'application/json' },
});

// ── Request interceptor: attach JWT from sessionStorage ──────────────────────
api.interceptors.request.use(
    (config) => {
        // Read from sessionStorage (wiped when tab closes)
        const token = sessionStorage.getItem('exam_portal_token');
        if (token) {
            config.headers.Authorization = `Bearer ${token}`;
        }
        return config;
    },
    (error) => Promise.reject(error)
);

// ── Response interceptor: handle errors globally ─────────────────────────────
api.interceptors.response.use(
    (response) => response,
    (error) => {
        if (!error.response) {
            console.error('Network Error: Check your internet connection.');
        } else if (error.response.status === 401) {
            // Token expired or invalid → force logout, but NOT during an active exam
            const onExamPage = window.location.pathname.startsWith('/student/exam');
            if (!onExamPage) {
                sessionStorage.removeItem('exam_portal_token');
                sessionStorage.removeItem('exam_portal_user');
                localStorage.removeItem('exam_portal_token');
                localStorage.removeItem('exam_portal_user');
                if (window.location.pathname !== '/login') {
                    window.location.href = '/login';
                }
            }
        } else if (error.response.status >= 500) {
            console.error('Server error:', error.response.data);
        }
        return Promise.reject(error);
    }
);

export default api;
